<template>
  <div class="exchange-list">
    <div class="one-exchange" v-if="prizeDataLength==1" v-for="(item, index) in prizeData">
      <div class="parent-wrap">
        <div class="line-circle-wrap">
          <div id='leftCover'></div>
          <div class="card-dom">
            <div class="card-box">
              <div class="card-title">{{item.couponName}}</div>
              <div class="card-subtitle">
                <div class="left">
                  <div>{{ item.couponSubtitle }}</div>
                  <div v-if="item.useStaus==1">请于 <span>{{ item.couponTime.split(" ")[0] }}</span> 前使用</div>
                  <div v-if="item.useStaus==2">已于 <span>{{ item.couponTime.split(" ")[0] }}</span> 使用</div>
                  <div v-if="item.useStaus==3">已于 <span>{{ item.couponTime.split(" ")[0] }}</span> 过期</div>
                  <div @click="toDetail(index)">详细信息<img :class="detailType && onlyCurrentIndex==index?'trianglesh':'triangle'"
                                                             src="../../../assets/pointsActivity/xialajiantou-xia.png"></div>
                </div>
              </div>
            </div>
            <div class="card-box-right">
              <!--未使用-->
              <div v-if="item.useStaus==1" class="right" @click="onlyOmmediateUse(item)">立即使用</div>
              <!--已使用-->
              <div class="right-dom" v-if="item.useStaus==2">
                <img class="right-pic" src="../../../assets/pointsActivity/use-img.png">
              </div>
              <!--已过期-->
              <div class="right-dom" v-if="item.useStaus==3">
                <img class="right-pic" src="../../../assets/pointsActivity/expire-img.png">
              </div>
            </div>
            <div v-if="detailType && onlyCurrentIndex==index" class="detail-text">
              {{ item.couponDesc }}
            </div>
          </div>
          <div id='rightCover'></div>
        </div>
      </div>
    </div>
    <div class="exchange-item" v-if="prizeDataLength!=1" v-for="(item, index) in prizeData">
      <div class="exchange-box">
        <img class="exchange-pic" :src="item.fileUrl"/>
        <div class="detail-box">
          <div class="detail-title">
            <div class="title">{{ item.couponName }}</div>
            <div class="subtitle">{{ item.couponSubtitle }}</div>
            <div class="subtitle" v-if="item.useStaus==1">请于<span class="date">{{ item.couponTime.split(" ")[0] }}</span>前使用</div>
            <div class="subtitle" v-if="item.useStaus==2">已于<span class="date">{{ item.couponTime.split(" ")[0] }}</span>使用</div>
            <div class="subtitle" v-if="item.useStaus==3">已于<span class="date">{{ item.couponTime.split(" ")[0] }}</span>过期</div>
            <div class="subtitle styicon" @click="showDetail(index)">
              详细信息
              <img :class="showDetailType && index==currentIndex?'trianglesh':'triangle'"
                   src="../../../assets/pointsActivity/xialajiantou-xia.png">
            </div>
          </div>
          <!--未使用-->
          <div class="detail-btn" v-if="item.useStaus==1" @click="immediateUse(item)">立即使用</div>
          <!--已使用-->
          <div v-if="item.useStaus==2" class="right-dom">
            <img class="statusType" src="../../../assets/pointsActivity/use-img.png"/>
          </div>
          <!--已过期-->
          <div v-if="item.useStaus==3" class="right-dom">
            <img class="statusType" src="../../../assets/pointsActivity/expire-img.png"/>
          </div>
        </div>
      </div>
      <div class="fulldetail" v-if="showDetailType && index==currentIndex">{{ item.couponDesc }}</div>
      <div class="divider"></div>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
export default {
  name: "exchange",
  props: {
    prizeDataLength: {
      type: Number,
      default: 0,
    },
    prizeData: {
      type: Array,
      default: [],
    },
    linkTerminal: {
      type: String,
      default: undefined,
    }
  },
  watch: {
  },
  data() {
    return {
      onlyCurrentIndex: 0,
      currentIndex: 0,
      showDetailType: false,
      detailType: false,
    }
  },
  mounted() {
  },
  methods: {
    onlyOmmediateUse(item){
      if (this.linkTerminal == 3) {
        const data = `{"path":"${item.appUrl}"}`;
        CottiNavigation.postMessage(data);
      } else if (this.linkTerminal == 2 || this.linkTerminal == undefined) {
        wx.miniProgram.navigateTo({
          url: `/${item.weChatUrl}`,
        });
      }
    },
    immediateUse(item){
      if (this.linkTerminal == 3) {
        const data = `{"path":"${item.appUrl}"}`;
        CottiNavigation.postMessage(data);
      } else if (this.linkTerminal == 2 || this.linkTerminal == undefined) {
        wx.miniProgram.navigateTo({
          url: `/${item.weChatUrl}`,
        });
      }
    },
    showDetail(index) {
      this.currentIndex = index
      this.showDetailType = !this.showDetailType
    },
    toDetail(index) {
      this.onlyCurrentIndex = index
      this.detailType = !this.detailType
    }
  },
}
</script>

<style lang="scss" scoped>
.exchange-list {
  width: 100%;

  .one-exchange:last-child{
    margin-bottom: 0;
  }
  .one-exchange {
    margin-bottom: 24px;
    width: 100%;

    .parent-wrap {
      border: 2px solid #FDF8F5;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
      border-radius: 8px;

      .card-dom{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;

        .card-box {
          width: calc(100% - 114px);
          .card-title {
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #3A3B3C;
          }

          .card-subtitle {
            position: relative;
            display: flex;
            justify-content: space-between;

            .left {
              font-size: 20px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;

              div:first-child {
                color: #3A3B3C;
              }

              span {
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3A3B3C;
              }

              div:last-child {
                display: flex;
                align-items: center;
                color: #5E5E5E;
              }

              div {
                margin-top: 12px;
              }


              .triangle {
                width: 24px;
                height: 24px;
                margin-left: 8px;
              }

              .trianglesh {
                width: 24px;
                height: 24px;
                margin-left: 8px;
                transform: rotate(180deg);
              }
            }


          }

          .card-line {
            border: 2px dashed #EEEEEE;
          }



        }
        .detail-text {
          padding-top: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-size: 20px;
          font-weight: 400;
          color: #5E5E5E;
          width: 100%;
          margin-top: 24px;
          border-top: 1px solid transparent;
          background: linear-gradient(#FDF8F5, #FDF8F5) padding-box,
          repeating-linear-gradient(-45deg, #ccc 0, #ccc 10px, white 0, white 15px);
        }
        .card-box-right{
          width: 112px;
          .right {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 112px;
            height: 48px;
            margin: auto 0;
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            background: #A52337;
            border-radius: 8px;
          }

          .right-dom{
            width: 112px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .right-pic{
            margin: auto 0;
            width: 96px;
            height: 96px;
          }
        }
      }


      .line-circle-wrap {
        background: #FDF8F5;
        padding: 24px 28px;
        position: relative;
        display: flex;
        align-items: center;

        .line {
          width: 100%;
          border: 0 none;
          border-top: 1.4px dotted rgba(0, 0, 0, 0);
        }

        &::before, &::after {
          content: ''
        }

        &::before, &::after, #leftCover, #rightCover {
          position: absolute;
          left: -12px;
          top: 0;
          bottom: 0;
          margin: auto;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background: #fff;
          z-index: 1;
          box-shadow: inset -12px 0px 6px -8px rgba(0, 0, 0, 0.12);
        }

        &::after, #rightCover {
          left: inherit;
          right: -12px;
          box-shadow: inset -12px 0px 6px -8px rgba(0, 0, 0, 0.1);
        }

        &::after, #leftCover {
          left: inherit;
          right: -12px;
          transform: rotate(180deg);
          box-shadow: inset -12px 0px 6px -8px rgba(0, 0, 0, 0.1);
        }

        #leftCover, #rightCover {
          box-shadow: none;
          width: 24px;
          height: 24px;
          filter: blur(5px);
          z-index: 2;
        }

        #leftCover {
          display: none;
          left: -20px;
        }

        #rightCover {
          right: -20px;
        }
      }
    }
  }

  .exchange-item {
    width: 100%;

    .usedtitle {
      color: #89898A !important;
    }

    .usedsubtitle {
      color: #A4A4A4 !important;
    }

    .useddata {
      color: #8D8E8E !important;
    }

    .usedexchange-pic {
      opacity: 0.3;
    }

    .usefulldetail {
      color: #848484 !important;
    }

    .exchange-box {
      width: 100%;
      display: flex;

      .exchange-pic {
        width: 228px;
        height: 160px;
        border-radius: 8px;
      }

      .detail-box {
        position: relative;
        margin: 4px 0 4px 24px;
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        .detail-title {
          width: calc(100% - 116px);

          .title {
            line-height: 40px;
            font-size: 28px;
            color: #3A3B3C;
            font-family: PingFangSC-Medium, PingFang SC;
          }

          .subtitle {
            font-size: 20px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #5E5E5E;
            margin-top: 12px;
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1; /* 这里是超出几行省略 */
            overflow: hidden;

            .date {
              font-size: 20px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #3A3B3C;
              margin: 0 8px;
            }

            .triangle {
              width: 24px;
              height: 24px;
              margin-left: 8px;
            }

            .trianglesh {
              width: 24px;
              height: 24px;
              margin-left: 8px;
              transform: rotate(180deg);
            }
          }

          .styicon {
            display: flex;
            align-items: center;
          }
        }

        .right-dom{
          width: 112px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .detail-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 110px;
          height: 44px;
          border: 2px solid #A52337;
          border-radius: 8px;
          color: #A52337;
          font-size: 20px;
          margin: auto 0;
          font-family: PingFangSC-Medium, PingFang SC;
        }
      }

      .statusType {
        width: 96px;
        height: 96px;
      }
    }

    .fulldetail {
      font-family: PingFangSC-Regular, PingFang SC;
      font-size: 20px;
      font-weight: 400;
      color: #5E5E5E;
      margin: 24px 16px 0 16px;
      white-space: pre-wrap;
    }

    .divider {
      margin: 24px 0 22px 0;
      width: 100%;
      height: 1px;
      background: #EEEEEE;
    }
  }

  .exchange-item:last-child {
    .divider {
      display: none;
    }
  }
}
</style>
